import { withNamespaces } from "react-i18next";
import { useMemo } from "react";
import {
    Alert,
    Card,
    CardBody,
    Col,
    Container,
    Row
} from 'reactstrap';
import { useLocation } from "react-router-dom";
import Navigator from "src/components/Navigator";
import Tabs from "./components/tabs";

import Dashboard from "./tabs-contents/dashboard";
import Overview from "./tabs-contents/overview";
import HistoryLogs from "./tabs-contents/history";
import { isFeatureEnabledForActiveModule } from "src/helpers/module_helper";
import Queries from "./tabs-contents/queries";

const ComplianceMonitoringDashboard = ({ t }) => {
    const location = useLocation();

    const renderSelectedTabContent = () => {
        const searchParams = new URLSearchParams(location.search);

        switch (searchParams.get("tab")) {
            case "dashboard":
                return (
                    <Dashboard />
                )

            case "overview":
                return (
                    <Overview />
                )

            case "queries":
                return (
                    <Queries />
                )

            case "tasks":
                return (
                    <div>
                        tasks
                    </div>
                )

            case "history":
                return (
                    <HistoryLogs />
                )

            default:
                return null
        }
    };

    const navigatorOptions = useMemo(() => {
        const tabKey = new URLSearchParams(location.search).get("tab") || "dashboard";
        const tabTitles = {
            dashboard: "Dashboard",
            overview: "Overview",
            queries: "Queries",
            tasks: "Tasks",
            history: "History Log",
        };
        const tabTitle = tabTitles[tabKey] || "Dashboard";

        return {
            translate: false,
            backButtonOptions: () => {
                return {
                    enable: false,
                    title: t("Back"),
                    icon: <i className="ri-arrow-left-fill"></i>
                }
            },
            breadCrumbs: [
                {
                    title: t("SIP"),
                    link: "/admin/3rd-party/dashboard"
                },
                {
                    title: "Compliance Monitoring",
                    link: "/admin/3rd-party/compliance/monitoring?tab=dashboard"
                },
                {
                    title: t(tabTitle),
                    link: "#"
                }
            ],
            pageTitle: 'Compliance Monitoring'
        }
    }, [ t, location.search ]);

    return (
        <div className="page-content">
            <Container fluid>
                <Row>
                    <Col lg="12" className="mb-4">
                        <Navigator {...navigatorOptions} />
                    </Col>

                    <Col lg="12" className="mb-4">
                        {isFeatureEnabledForActiveModule('compliance_monitoring_activation') ? (
                            <div className="details-content-wrapper">
                                <Tabs />

                                <Row>
                                    <Col xl="12">
                                        <Card style={{ marginBottom: '0px' }}>
                                            <CardBody className="tabOverview">
                                                <div className="d-flex flex-column gap-4 mb-4">
                                                    {renderSelectedTabContent()}
                                                </div>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>
                            </div>
                        ) : (
                            <Alert
                                color="warning"
                            >
                                <p className="mb-0">
                                    {t("Please upgrade your plan to access this feature")}.
                                </p>
                            </Alert>
                        )}
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default withNamespaces()(ComplianceMonitoringDashboard);